module.exports = __webpack_public_path__ + "assets/img/car10.8a2661eb.jpg";